import type { ExtendedFetchOptions } from '@/types/api-client'
import type {
	DeviceRebootRequest,
	DeviceRebootResponse,
	DeviceStatusRequest,
	DeviceStatusResponse
} from '@/types/api-client/device-tools'

export function createDeviceToolsApi(
	request: <T>(endpoint: string, options?: ExtendedFetchOptions) => Promise<T | null>
) {
	return {
		checkDeviceStatus: (accountId: number, payload: Omit<DeviceStatusRequest, 'accountId'>, options: ExtendedFetchOptions = {}) => {
			return request<DeviceStatusResponse>(`/account/${accountId}/deviceStatus`, {
				method: 'POST',
				body: {
					accountId,
					...payload
				},
				...options
			})
		},
		rebootDevice: (accountId: number, payload: Omit<DeviceRebootRequest, 'accountId'>, options: ExtendedFetchOptions = {}) => {
			return request<DeviceRebootResponse>(`/account/${accountId}/rebootDevice`, {
				method: 'POST',
				body: {
					accountId,
					...payload
				},
				...options
			})
		}
	}
}
